export default {
  path : 'finanCertificate/list',
  name : 'finance-finanCertificate',
  component : () => import(/* webpackChunkName: "finanCertificate" */ "../pages/finance/finanCertificate")
}
